import { prefixObjectValues } from '../utils';

const verifyAssociation = {
  page: 'page',
  employerName: 'employer-name',
  acceptBtn: 'accept-btn',
  declineBtn: 'decline-btn',
  signInLink: 'sign-in-link',
  loading: 'loading',
  invalidMsg: 'invalid-msg',
  wrongAccount: 'wrong-account',
  wrongAccountSignOutBtn: 'wrong-account-sign-out-btn',
  successMsg: 'success-msg',
  alreadyDeclined: 'already-declined',
  alreadyAssociated: 'already-associated',
  alreadyAssociatedSettingsLink: 'already-associated-settings-link',
  continueLink: 'continue-link',
};

export default prefixObjectValues(verifyAssociation, 'verify-association');
